import { User } from '../Modules/User/Model/User';

type UserPermissionFields = Pick<
  User,
  | 'grade'
  | 'is_limited_partner_admin'
  | 'external_partner_flags'
  | 'can_delete_logs'
  | 'can_manage_slot_ops_time_settings'
>;

/** 제한형 외부 ADMIN (API boolean 또는 `limited-admin` 플래그) */
export function isLimitedPartnerAdmin(
  user: UserPermissionFields | null | undefined,
): boolean {
  if (!user || user.grade !== 'ADMIN') return false;
  if (user.is_limited_partner_admin) return true;
  return user.external_partner_flags?.includes('limited-admin') ?? false;
}

/** 슬롯 작업 시간 제한 설정 가능 여부 (일반 ADMIN만, 제한형은 불가) */
export function canManageSlotOpsTimeSettings(
  user: UserPermissionFields | null | undefined,
): boolean {
  if (!user || user.grade !== 'ADMIN') return false;
  if (isLimitedPartnerAdmin(user)) return false;
  if (user.can_manage_slot_ops_time_settings === false) return false;
  return true;
}

/** 로그 삭제 가능 여부 (ADMIN + 비제한형 + block-log-delete 미설정) */
export function canDeleteLogs(user: UserPermissionFields | null | undefined): boolean {
  if (!user || user.grade !== 'ADMIN') return false;
  if (isLimitedPartnerAdmin(user)) return false;
  if (user.external_partner_flags?.includes('block-log-delete')) return false;
  if (user.can_delete_logs === false) return false;
  return true;
}
